export default __webpack_public_path__ + "static/kyeonga.jeon-d47a99efc2837d5180579a0af823e634.jpeg";